const columns = [
	{
		id: 'account_name',
		name: 'Account Name',
		selector: row => row.account_name,
		cell: row => row.account_name,
		width: '1fr'
	}, {
		id: 'hq',
		name: 'HQ',
		selector: row => row.hq,
		cell: row => row.hq,
		width: '1fr'
	}, 
	{
		id: 'address',
		name: 'Address',
		selector: row => row.address,
		cell: row => row.address,
		width: '1fr'
	}, {
		id: 'industry_name',
		name: 'Industry',
		selector: row => row.industry,
		cell: row => row.industry,
		width: '1fr'
	}, {
		id: 'website',
		name: 'Website',
		selector: row => row.website,
		cell: row => row.website,
		width: '1fr'
	},  {
		id: 'region_name',
		name: 'Region',
		sortable: false,
		selector: row => row.region_name,
		cell: row => row.region_name,
		width: '1fr'
	}
];

export default columns;
